// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"castle-3"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17 21V11H7V21H17Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M3 21H7V11H9V4H3V21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M21 21V4H15V11H17V21H21Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 4H3M9 4V11H7V21H3V4M9 4V3M3 4V3M21 4V21H17V11H15V4M21 4H15M21 4V3M15 4V3M12 21V16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 21V11H7V21H17Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Castle3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'castle-3',
    ref,
    icon: element,
  },
));

Castle3Icon.displayName = 'Castle3Icon';

export default Castle3Icon;
